export default __webpack_public_path__ + "images/539454307bd92309efa4448b47f4582b.png";